<script setup lang="ts"></script>
<template>
    <sbx-icon>
        <svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M 32.703 11.773 L 25 4.07 L 17.297 11.773 L 15.262 9.738 L 25 0 L 34.738 9.738 L 32.703 11.773 Z"
                style="fill: rgb(6, 121, 254)"
            />
            <path
                d="M 23.547 2.035 L 26.453 2.035 L 26.453 32.558 L 23.547 32.558 L 23.547 2.035 Z"
                style="fill: rgb(6, 121, 254)"
            />
            <path
                d="M 39.535 50 L 10.465 50 C 7.994 50 6.105 48.11 6.105 45.64 L 6.105 19.477 C 6.105 17.006 7.994 15.116 10.465 15.116 L 20.64 15.116 L 20.64 18.023 L 10.465 18.023 C 9.593 18.023 9.012 18.605 9.012 19.477 L 9.012 45.64 C 9.012 46.512 9.593 47.093 10.465 47.093 L 39.535 47.093 C 40.407 47.093 40.988 46.512 40.988 45.64 L 40.988 19.477 C 40.988 18.605 40.407 18.023 39.535 18.023 L 29.36 18.023 L 29.36 15.116 L 39.535 15.116 C 42.006 15.116 43.895 17.006 43.895 19.477 L 43.895 45.64 C 43.895 48.11 42.006 50 39.535 50 Z"
                style="fill: rgb(6, 121, 254)"
            />
        </svg>
    </sbx-icon>
</template>
<style scoped></style>
